module.exports = function() {
  return new Worker(__webpack_public_path__ + "40f5daace232bf478b87.worker.js");
};